/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Annotation Portal React Context Provider
import { MaterialUIControllerProvider } from "context";
import { initBrowserSession } from "services/browserSession";

const container = document.getElementById("app");
const root = createRoot(container);

// Clear a login left behind by a closed browser before any page can render it.
initBrowserSession().then(() => {
  root.render(
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  );
});
